module.exports = __webpack_public_path__ + "static/media/PushtimargImage47.a8806b15.jpg";